<template>
  <!-- MODAL EDIT -->
  <b-modal
    id="Live1"
    title="Live"
    size="lg"
    ok-only
  >
    <b-row>
      <!-- GATEWAY NAME -->

      <b-col cols="12">
        <video
          id="live"
          poster="@/assets/images/icons/no-signal.gif"
          style="width:100%; height:auto;"
          muted
          playsinline
        />
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import Hls from 'hls.js'
import {
  BRow, BCol,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    // MAP
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
    streamLive(value) {
      setTimeout(() => {
        const hls = new Hls({
          lowLatencyMode: true,
          autoreconnect: true,
        })
        const stream = value
        const video = document.querySelector('#live')
        hls.loadSource(stream)
        hls.attachMedia(video)
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
          console.log(video)
        })
        hls.on(Hls.Events.ERROR, () => {
          video.play()
          console.log(video)
        })
      }, 500)
    },
  },
}
</script>

<style lang="scss">
</style>
